<template>
    <v-container fluid>
      <v-row no-gutters>
        <v-col>
          <v-list>
            <v-list-item two-line>
              <v-subheader>{{ $vuetify.lang.t('$vuetify.map.userFeedback.drowsiness') }}</v-subheader>
              <v-list-item-content>
                <v-list-item-title>
                  <v-rating color="amber" :value="drowsinessFeedback" length="9" dense readonly></v-rating>
                </v-list-item-title>
                <v-list-item-subtitle class="ml-2">
                  <span class="caption font-weight-light font-italic">{{ $vuetify.lang.t(`$vuetify.map.drowsinessCaption.${[drowsinessFeedback - 1]}`) }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-subheader>{{ $vuetify.lang.t('$vuetify.map.userFeedback.drivingStyle') }}</v-subheader>
              <span>{{ aggressivenessFeedbackLabel }}</span>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'userFeedbackView',
  props: {
    drowsinessFeedback: Number,
    aggressivenessFeedback: Number
  },
  computed: {
    aggressivenessFeedbackLabel () {
      return this.$vuetify.lang.t(`$vuetify.map.userFeedbackForm.drivingStyle.${this.aggressivenessFeedback ? 'aggressive' : 'calm'}`)
    }
  }
}
</script>

<style scoped>

</style>
